(function () {
  if (window.__birthdayGiftInit) return;
  window.__birthdayGiftInit = true;

  function getConfig() {
    return window.BirthdayGiftConfig || null;
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Failed to load cart');
    return await res.json();
  }

  function subtotalExcludingGiftAndProtection(cart, excludeProductIds) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      for (var i = 0; i < excludeProductIds.length; i++) {
        if (Number(item.product_id) === Number(excludeProductIds[i])) return;
      }
      sum += Number(item.final_line_price || 0);
    });
    return sum;
  }

  function findGiftLine(cart, giftVariantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === Number(giftVariantId)) {
        return cart.items[i];
      }
    }
    return null;
  }

  async function addGift(variantId) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });
    if (!res.ok) throw new Error('Failed to add gift');
  }

  async function removeGift(lineKey) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!res.ok) throw new Error('Failed to remove gift');
  }

  async function capGiftQty(lineKey, qty) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
    if (!res.ok) throw new Error('Failed to cap gift qty');
  }

  /* ---- Mini-cart refresh (matches theme pattern) ---- */

  function refreshCartUI() {
    if (window.miniCart && typeof window.miniCart.renderContents === 'function') {
      fetch('/cart?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          window.miniCart.renderContents({ sections: sections });
        })
        .catch(function () {});
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  /* ---- Core evaluate ---- */

  var evaluating = false;

  async function evaluate() {
    if (evaluating) return;
    evaluating = true;

    var config = getConfig();
    if (!config) { evaluating = false; return; }

    try {
      var cart = await fetchCart();
      var giftLine = findGiftLine(cart, config.giftVariantId);
      var subtotal = subtotalExcludingGiftAndProtection(cart, config.excludeProductIds);
      var qualifies = subtotal >= config.thresholdCents;

      if (qualifies && !giftLine) {
        /* Threshold met, no gift yet — add it */
        await addGift(config.giftVariantId);
        refreshCartUI();

      } else if (qualifies && giftLine && giftLine.quantity > config.maxQty) {
        /* Gift present but too many — cap at 1 */
        await capGiftQty(giftLine.key, config.maxQty);
        refreshCartUI();

      } else if (!qualifies && giftLine) {
        /* Dropped below threshold — remove gift */
        await removeGift(giftLine.key);
        refreshCartUI();
      }
    } catch (err) {
      console.warn('[Birthday Gift]', err);
    } finally {
      evaluating = false;
    }
  }

  /* ---- Observe mini-cart changes (same as theme pattern) ---- */

  function observeMiniCart() {
    var target = document.querySelector('mini-cart') ||
                 document.querySelector('.mini-cart') ||
                 document.querySelector('#cart-drawer');
    if (!target) return;

    var observer = new MutationObserver(function () {
      /* Debounce to let the cart finish rendering */
      clearTimeout(observer._timer);
      observer._timer = setTimeout(function () {
        if (!evaluating) evaluate();
      }, 800);
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  /* ---- Init ---- */

  function init() {
    /* Initial evaluation */
    evaluate();

    /* Watch for mini-cart DOM changes (covers add-to-cart, qty changes, removals) */
    observeMiniCart();

    /* Re-check on tab focus (user may have modified cart in another tab) */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        evaluate();
      }
    });

    /* Re-check on pageshow (back/forward cache) */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        evaluate();
      }
    });

    /* Listen for theme cart-update events */
    document.addEventListener('cart:updated', function () {
      /* Small delay so we don't re-enter during our own refresh */
      setTimeout(function () {
        if (!evaluating) evaluate();
      }, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
